
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/s/[exchange]/[ticker]/trading-signals",
      function () {
        return require("private-next-pages/s/[exchange]/[ticker]/trading-signals/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/s/[exchange]/[ticker]/trading-signals"])
      });
    }
  